import * as React from 'react';
import { styled, Checkbox, FormControlLabel } from '@mui/material';
import CheckIcon from '@assets/check_icon.svg';

const BpIcon = styled('span')(({ theme }) => ({
  width: 24,
  height: 24,
  padding: 0,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.colors.dark.steelBlue}`,
  backgroundColor: theme.colors.light.lightBlue,

  '.Mui-focusVisible &': {},
  'input:hover ~ &': {},
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(57,75,89,.5)'
        : 'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)(({ theme }) => ({
  backgroundColor: theme.colors.light.lightBlue,
  borderColor: theme.colors.orange.orange,
  '&:before': {
    display: 'block',
    width: 24,
    height: 24,
    backgroundImage: `url(${CheckIcon})`,
    content: '""',
    backgroundPosition: 'center',
    backgroundSize: '12px',
    backgroundRepeat: 'no-repeat',
  },
  'input:hover ~ &': {},
}));

export default function CheckboxLabel({ name, checked, label, onChange }) {
  return (
    <FormControlLabel
      sx={{ mx: 0, minWidth: 125 }}
      componentsProps={{ typography: { variant: 'caption' } }}
      control={
        <Checkbox
          sx={{
            pl: 0,
            '&:hover': { bgcolor: 'transparent' },
          }}
          disableRipple
          color="default"
          checkedIcon={<BpCheckedIcon />}
          icon={<BpIcon />}
          inputProps={{ 'aria-label': 'custom-checkbox' }}
          name={name}
          checked={checked}
          onChange={e => onChange(e, label)}
        />
      }
      label={label}
    />
  );
}
